// search bar
$(document).ready(function () {
  $('#searchInput').on('input', function () {
    var searchText = $(this).val().trim().toLowerCase();
    var foundResults = false;

    $('.accordion').each(function () {
      var accordionText = $(this).text().toLowerCase();
      if (accordionText.includes(searchText)) {
        $(this).show();
        foundResults = true;
      } else {
        $(this).hide();
      }
    });

    // Hide/show category divs based on search text
    if (searchText !== '') {
      $('.faq__category.h4').hide();
    } else {
      $('.faq__category.h4').show();
    }

    // Show/hide no-results message based on search results
    if (foundResults) {
      $('.no-results').hide();
    } else {
      $('.no-results').show();
    }
  });
});
 // add header class
document.addEventListener("DOMContentLoaded", function () {
    let navElement = document.querySelector(".header__primary-nav--center");
    
    if (navElement) {
        let headerParent = navElement.closest(".header");
        if (headerParent) {
            headerParent.classList.add("new-one");
        }
    }
});
$(document).ready(function() {
  $('input[name="contact[name]"]').on('blur', function() {
    var input = $(this).val().trim();
    var letterRegex = /[a-zA-Z]/;
    
    if (!letterRegex.test(input)) {
      alert('Please input a character between [0 and 9] and [a to z].');
      $('form#contact_form .button').css('pointer-events', 'none');
    } else {
      $('form#contact_form .button').css('pointer-events', 'auto');
    }
  });
});
jQuery(document).ready(function() {
  $('input[name="contact[Phone]"]').on('keypress', function(event) {
    var key = event.which;

    // Allow only numbers (0-9), backspace (8), and delete (46)
    if ((key < 48 || key > 57) && key !== 8 && key !== 46) {
      event.preventDefault();
    }
  });

  // Ensure only numeric values remain on blur
  $('input[name="contact[Phone]"]').on('input', function() {
    $(this).val($(this).val().replace(/\D/g, '')); // Remove non-numeric characters
  });
});
